// Description: Fifth step of the campaign creation process
// Updated: 26/09/2025
// Author: Simon Franklin

// React
import React from 'react';

// Material UI Components
import { Box, Button, Checkbox, MenuItem, Select } from '@mui/material';

// Components and Functions for the project
import StatusIcon from '../../../components/StatusLabel/StatusIcon';
import themeColors from '../../../components/ThemeColors/ThemeColors';
import { useNavigate } from 'react-router-dom';
import TemplatesModal from './TemplatesModal';

// Render The Component
const Step5 = ({ formState, error, setError, updateFieldValue, wppOptions, smsOptions, emailOptions, templateOptions }) => {
  const navigate = useNavigate();
  const [open, setOpen] = React.useState(false);
  const [field, setField] = React.useState(false);
  const [templateType, setTemplateType] = React.useState("")
  const [dataToTable, setDataToTable] = React.useState(templateOptions);

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: "32px", marginTop: "60px" }}>

      <Box component="div" sx={{ display: "flex", flex: 1, width: "100%" }}>
        <p style={{ fontSize: "16px", flex: 0.5 }}>Enviar</p>
        <p style={{ fontSize: "16px", flex: 1, maxWidth: "203px" }}>Tipo</p>
        <p style={{ fontSize: "16px", flex: 1, marginRight: "40px" }}>Canal</p>
        <p style={{ fontSize: "16px", flex: 1 }}>Modelo</p>
      </Box>

      <Box component="div" sx={{ display: "flex", flex: 1, width: "100%" }}>

        <div style={{ display: "flex", flex: 0.5, justifyContent: "start" }}>

          <Checkbox
            checked={formState["Enviar WhatsApp"] === true}
            onChange={(e) => {
              if (formState["Enviar WhatsApp"] === true) {
                updateFieldValue("Enviar WhatsApp", false);
              } else {
                updateFieldValue("Enviar WhatsApp", true);
              }
              if (error["Enviar WhatsApp"] === true) {
                setError((prev) => ({
                  ...prev,
                  "Enviar WhatsApp": false
                }));
              }
            }}
            inputProps={{ "aria-label": "controlled" }}
          />
        </div>

        <div style={{ flex: 1, display: "flex", fontSize: "16px", gap: "13px", alignItems: "center", maxWidth: "203px", pointerEvents: formState["Enviar WhatsApp"] === false ? "none" : "auto", opacity: formState["Enviar WhatsApp"] === false ? "0.5" : "1" }}>
          <StatusIcon status={"WhatsApp"} /> WhatsApp
        </div>

        <div style={{ flex: 1, marginRight: "40px", pointerEvents: formState["Enviar WhatsApp"] === false ? "none" : "auto", opacity: formState["Enviar WhatsApp"] === false ? "0.5" : "1" }}>
          <Select
            name={"Canal WhatsApp"}
            sx={{
              backgroundColor: error["Canal WhatsApp"] === true ? themeColors.red01 : '#FFF',
              borderRadius: "6px",
              minWidth: "100%",
              ".css-11u53oe-MuiSelect-select-MuiInputBase-input-MuiOutlinedInput-input": {
                padding: "13px",
              },
            }}
            onChange={(e) => {
              const value = e.target.value;

              updateFieldValue("Canal WhatsApp", value);

              if (error["Canal WhatsApp"] === true) {
                setError((prev) => ({
                  ...prev,
                  "Canal WhatsApp": false
                }));
              }
            }}
            value={formState["Canal WhatsApp"]}
          >
            <MenuItem style={{ color: themeColors.gray30 }} value={""} disabled>
              {"Canal WhatsApp"}
            </MenuItem>
            {
              Array.isArray(wppOptions) && wppOptions.map((option, index) => (
                <MenuItem key={index} value={option.id} onClick={() => {
                  if (option.title === "Adicionar Canal") {
                    navigate(option.path)
                    sessionStorage.setItem("formState", JSON.stringify(formState))
                    sessionStorage.setItem("currentStep", JSON.stringify(4))
                    sessionStorage.setItem("creating_campaign", JSON.stringify(true))
                  } else {
                    return;
                  }
                }}>
                  {option.title}
                </MenuItem>
              ))
            }
          </Select>
        </div>

        <div style={{ flex: 1, pointerEvents: formState["Enviar WhatsApp"] === false ? "none" : "auto", opacity: formState["Enviar WhatsApp"] === false ? "0.5" : "1" }}>
          <Button onClick={() => {
            setOpen(true);
            setDataToTable(templateOptions.filter((m) => String(m.channel_type).includes("WhatsApp")));
            setTemplateType("WhatsApp");
            setField("Modelo WhatsApp");
          }} variant="contained" sx={{ width: "298px", height: "37.73px", display: "flex", justifyContent: "center", alignItems: "center" }}>
            {
              formState["Modelo WhatsApp"] !== "" ? (
                "Modelo Selecionado!"
              ) : (
                "Selecionar Modelo"
              )
            }
          </Button>
        </div>
      </Box>

      <Box component="div" sx={{ display: "flex", flex: 1, width: "100%" }}>

        <div style={{ display: "flex", flex: 0.5, justifyContent: "start" }}>
          <Checkbox
            checked={formState["Enviar SMS"] === true}
            onChange={(e) => {
              if (formState["Enviar SMS"] === true) {
                updateFieldValue("Enviar SMS", false);
              } else {
                updateFieldValue("Enviar SMS", true);
              }
              if (error["Enviar SMS"] === true) {
                setError((prev) => ({
                  ...prev,
                  "Enviar SMS": false
                }));
              }
            }}
            inputProps={{ "aria-label": "controlled" }}
          />
        </div>

        <div style={{ flex: 1, display: "flex", fontSize: "16px", gap: "13px", alignItems: "center", maxWidth: "203px", pointerEvents: formState["Enviar SMS"] === false ? "none" : "auto", opacity: formState["Enviar SMS"] === false ? "0.5" : "1" }}>
          <StatusIcon status={"SMS"} /> SMS
        </div>

        <div style={{ flex: 1, marginRight: "40px", pointerEvents: formState["Enviar SMS"] === false ? "none" : "auto", opacity: formState["Enviar SMS"] === false ? "0.5" : "1" }}>
          <Select
            name={"Canal SMS"}
            sx={{
              backgroundColor: error["Canal SMS"] === true ? themeColors.red01 : '#FFF',
              borderRadius: "6px",
              minWidth: "100%",
              ".css-11u53oe-MuiSelect-select-MuiInputBase-input-MuiOutlinedInput-input": {
                padding: "13px",
              },
            }}
            onChange={(e) => {
              const value = e.target.value;

              updateFieldValue("Canal SMS", value);

              if (error["Canal SMS"] === true) {
                setError((prev) => ({
                  ...prev,
                  "Canal SMS": false
                }));
              }
            }}
            value={formState["Canal SMS"]}
          >
            <MenuItem style={{ color: themeColors.gray30 }} value={""} disabled>
              {"Canal SMS"}
            </MenuItem>
            {
              Array.isArray(smsOptions) && smsOptions.map((option, index) => (
                <MenuItem key={index} value={option.id} onClick={() => {
                  if (option.title === "Adicionar Canal") {
                    navigate(option.path)
                    sessionStorage.setItem("formState", JSON.stringify(formState))
                    sessionStorage.setItem("currentStep", JSON.stringify(4))
                    sessionStorage.setItem("creating_campaign", JSON.stringify(true))
                  } else {
                    return;
                  }
                }}>
                  {option.title}
                </MenuItem>
              ))
            }
          </Select>
        </div>

        <div style={{ flex: 1, pointerEvents: formState["Enviar SMS"] === false ? "none" : "auto", opacity: formState["Enviar SMS"] === false ? "0.5" : "1" }}>
          <Button onClick={() => {
            setOpen(true);
            setDataToTable(templateOptions.filter((m) => m.channel_type === "SMS"));
            setTemplateType("SMS");
            setField("Modelo SMS");
          }} variant="contained" sx={{ width: "298px", height: "37.73px", display: "flex", justifyContent: "center", alignItems: "center" }}>
            {
              formState["Modelo SMS"] !== "" ? (
                "Modelo Selecionado!"
              ) : (
                "Selecionar Modelo"
              )
            }
          </Button>
        </div>
      </Box>

      <Box component="div" sx={{ display: "flex", flex: 1, width: "100%" }}>

        <div style={{ display: "flex", flex: 0.5, justifyContent: "start" }}>
          <Checkbox
            checked={formState["Enviar Email"] === true}
            onChange={(e) => {
              if (formState["Enviar Email"] === true) {
                updateFieldValue("Enviar Email", false);
              } else {
                updateFieldValue("Enviar Email", true);
              }
              if (error["Enviar Email"] === true) {
                setError((prev) => ({
                  ...prev,
                  "Enviar Email": false
                }));
              }
            }}
            inputProps={{ "aria-label": "controlled" }}
          />
        </div>

        <div style={{ flex: 1, display: "flex", fontSize: "16px", gap: "13px", alignItems: "center", maxWidth: "203px", pointerEvents: formState["Enviar Email"] === false ? "none" : "auto", opacity: formState["Enviar Email"] === false ? "0.5" : "1" }}>
          <StatusIcon status={"Email"} /> Email
        </div>

        <div style={{ flex: 1, marginRight: "40px", pointerEvents: formState["Enviar Email"] === false ? "none" : "auto", opacity: formState["Enviar Email"] === false ? "0.5" : "1" }}>
          <Select
            name={"Canal Email"}
            sx={{
              backgroundColor: error["Canal Email"] === true ? themeColors.red01 : '#FFF',
              borderRadius: "6px",
              minWidth: "100%",
              ".css-11u53oe-MuiSelect-select-MuiInputBase-input-MuiOutlinedInput-input": {
                padding: "13px",
              },
            }}
            onChange={(e) => {
              const value = e.target.value;

              updateFieldValue("Canal Email", value);

              if (error["Canal Email"] === true) {
                setError((prev) => ({
                  ...prev,
                  "Canal Email": false
                }));
              }
            }}
            value={formState["Canal Email"]}
          >
            <MenuItem style={{ color: themeColors.gray30 }} value={""} disabled>
              {"Canal Email"}
            </MenuItem>
            {
              Array.isArray(emailOptions) && emailOptions.map((option, index) => (
                <MenuItem key={index} value={option.id} onClick={() => {
                  if (option.title === "Adicionar Canal") {
                    navigate(option.path)
                    sessionStorage.setItem("formState", JSON.stringify(formState))
                    sessionStorage.setItem("currentStep", JSON.stringify(4))
                    sessionStorage.setItem("creating_campaign", JSON.stringify(true))
                  } else {
                    return;
                  }
                }}>
                  {option.title}
                </MenuItem>
              ))
            }
          </Select>
        </div>

        <div style={{ flex: 1, pointerEvents: formState["Enviar Email"] === false ? "none" : "auto", opacity: formState["Enviar Email"] === false ? "0.5" : "1" }}>
          <Button onClick={() => {
            setOpen(true);
            setDataToTable(templateOptions.filter((m) => m.channel_type === "E-mail"));
            setTemplateType("E-mail");
            setField("Modelo Email");
          }} variant="contained" sx={{ width: "298px", height: "37.73px", display: "flex", justifyContent: "center", alignItems: "center" }}>
            {
              formState["Modelo Email"] !== "" ? (
                "Modelo Selecionado!"
              ) : (
                "Selecionar Modelo"
              )
            }
          </Button>
        </div>
      </Box>

      <TemplatesModal onClose={() => setOpen(false)} open={open} templateOptions={dataToTable} templateType={templateType} setError={setError} updateFieldValue={updateFieldValue} field={field} formState={formState} currentStep={4} />
    </div>
  )
}

export default Step5